import { ReactNode, ChangeEventHandler } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { classNames, Option } from '@pangea-lis-apps/utils';

import { Label } from '../label/label';

export interface SelectFieldProps {
	name: string;
	label?: string;
	value?: string;
	options: Option[];
	disabled?: boolean;
	required?: boolean;
	fieldAction?: ReactNode;
	showRequiredAsterisk?: boolean;
	info?: string | number;
	handleSelect: ChangeEventHandler<HTMLSelectElement> | undefined;
}

export function SelectField(props: SelectFieldProps) {
	return (
		<div>
			{props.label && (
				<div className="flex items-center justify-between">
					<Label
						name={props.name}
						label={props.label}
						required={props.required || props.showRequiredAsterisk}
					/>
					<div className="flex items-center gap-2">
						{props.info && (
							<InformationCircleIcon
								title={props.info.toString()}
								className="h-5 w-5 text-gray-500 hover:text-gray-700"
							/>
						)}
						{props.fieldAction && props.fieldAction}
					</div>
				</div>
			)}
			<select
				id={props.name}
				name={props.name}
				value={props.value}
				disabled={props.disabled}
				required={props.required}
				onChange={props.handleSelect}
				className={classNames(
					props.label ? 'mt-1' : '',
					'shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-100 disabled:text-gray-400 disabled:font-medium disabled:hover:cursor-not-allowed'
				)}
			>
				{props.options && props.options.length ? (
					props.options.map((item, index) => (
						<option
							key={index}
							value={item.value}
							disabled={item.disabled}
						>
							{item.label}
						</option>
					))
				) : (
					<option value="" disabled={true}>
						No options available
					</option>
				)}
			</select>
		</div>
	);
}

export default SelectField;
